export const actions = {
  injectMembers({ commit }, payload) {
    commit("INJECT_MEMBERS", payload);
  },
};
